// Module
var code = "<h2 id=\"reduce-payments\">Reduce Payments</h2> <p>If you can make smaller monthly payments, consider reducing them by changing payment plans, which can help decrease your monthly payments or enable you to make interest-only payments. </p> ";
// Exports
export default code;